
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opinmal",
      function () {
        return require("private-next-pages/opinmal.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/opinmal"])
      });
    }
  